export const _ACTIONS = {
  GET: "GET",
  POST: "POST",
  POSTFILE: "POSTFILE",
  PATCH: "PATCH",
  DELETE: "DELETE",
  PUT: "PUT",
};

export const _HTTP = {
  created: 201,
  ok: 200,
  noContent: 204,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  internalServerError: 500,
};

export const _RESULT = {
  success: "success",
  error: "error",
};

export const _CRUD = {
  create: "Create",
  read: "Read",
  update: "Edit",
  delete: "Delete",
};

export const _FORM_BTM = {
  save: "Save",
  cancel: "Cancel",
};

export const _MEMBER = "member";
export const _TOTALITEMS = "totalItems";

export const _COLORS = {
  grey: "#777a7f",
  lightGrey: "#f4f4f4",
  midGrey: "#D2D6DE",
  highGrey: "#4d4e51",
  darkGrey: "#534e48",
  buttonLightBlue: "#3c8dbc",
  drawerNav: "#1a2226",
  drawerNavCollapse: "#2c3b41",
  drawerNavCollapseHover: "#2E393D",
  lightBlue: "#3c8dbc",
  turquoiseBox: "#00c0ef",
  defaultGreen: "#57a85c",
  hoverDefaultGreen: "  #73b577",
  lightGreen: "#DFF0D8",
  defaultBlue: "#4fc1ef",
  error: "#C9302C",
  warning: "#F39C12",
  success: "#00a65a",
  lightDanger: "#D87A68",
  link: "#428fbc",
  white: "#fff",
  backgroundApp: "#ecf0f5",
  /*Ag-grid colors */
  headerAgGrid: "#c65911",
  totalAgGrid: "#fce4d6",
  totalLabourRow: "#92d050",
  groupTitleColor: "#0a73c1",
  groupRowColor: "#92D050",
  groupTotalRow: "#D1E5F4",
  groupBgColor: "#D3D3D3",
  groupDiscount: "#FFD769",
  productionSplit: "#ffff00",
  volumeRow: "#fef1d2",
};

export const _MESSAGES = {
  form_error: "Please check the form fields",
  success: "Operation completed successfully",
  data_sent: "Data saved successfully",
  error: "An error occurred",
  error2: "An error occurred. Please try again.",
  error_delete: "An error occurred during deletion",
  identifiants_invalides: "Invalid credentials",
  unAuthorized: "You are not authorized to access this resource",
  notFound: "The requested resource does not exist",
  emailsent: "Email has been sent to your email address",
  emailnotsent: "Email has not been sent",
  message_ticket_devis:
    "If you do not select a contract, the billable duration will not be deducted from the contract time.",
  field_required: "This field is required",
  saveSuccess: "Data saved successfully",
};

// @TODO ajouter les messages d'erreur de l'application
export const _SWAL_ICONS = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
  question: "question",
};

export const _SWAL_BTN = {
  Confirm: "Confirm",
  Cancel: "Cancel",
  Ok: "Ok",
};

export const _DATE_FORMAT = {
  input_time: "HH:mm",
  input_date: "yyyy-MM-DD",
  datetime: "YYYY-MM-DDTHH:mm",
  datetime_exact: "YYYY-MM-DDTHH:mm:ss.sssZ",
  date_minutes: "YYYY-MM-DDTHH:mm",
  date_display: "DD/MM/YYYY",
  hours_minutes: "HH:mm",
  month_letters: "MMMM",
  month: "MM",
  pretty: "dddd DD/MM/YYYY",
  pretty_tiny: "ddd DD/MM/YYYY",
  month_year: "MMMM YYYY",
  month_slash_year: "MM/YYYY",
  date_and_time_display: "DD/MM/YYYY - HH:mm",
  date_and_time_display_no_bar: "DD/MM/YYYY HH:mm",
  date_and_time_display_ss_no_bar: "DD/MM/YYYY HH:mm:ss",
  date_and_time: "YYYY-MM-DD HH:mm:ss",
  year: "YYYY",
  day: "DD",
  year_month: "YYYYMM",
  date_jour_letter_display: "DD MMMM YYYY",
  complete_date: "dddd DD MMMM YYYY",
  day_letter_date: "dddd",
  classic: "YYYY-MM-DDTHH:mm:ssZ",
  fileName: "DD_MM_YYYY_HH:mm:ss",
  next_display: "DD MMMM YYYY - HH:mm",
  day_letter_day: "dddd DD",
};

export const _CIVILITES = {
  Mr: "Mister",
  Ms: "Miss",
  Mrs: "Missus",
};

/**
 * Represents a mapping of language keys to their corresponding translations for a Material-UI table.
 *
 * @type {Object.<string, string>}
 */
export const _LANGUAGES_MUI_TABLE = {
  clearFilters: "Clear filters",
  rowsPerPage: "Rows per page",
  showHideColumns: "Show/Hide columns",
  showHideSearch: "Show/Hide search",
  showHideFilters: "Show/Hide filters",
  toggleFullScreen: "Full screen",
  hideAll: "Hide all",
  showAll: "Show all",
  resetOrder: "Reset",
  noRecordsToDisplay: "No records to display",
  search: "Search",
  toggleDensity: "Density",
  sortByColumnAsc: "Sort by {column} ascending",
  sortByColumnDesc: "Sort by {column} descending",
  resetColumnSize: "Reset column size",
  clearSort: "Clear sort",
  clearFilter: "Clear filter",
  clearSearch: "Clear search",
  hideColumn: "Hide {column} column",
  showAllColumns: "Show all columns",
  sortedByColumnAsc: "Sorted by {column} ascending",
  sortedByColumnDesc: "Sorted by {column} descending",
  of: "of",
  noResultsFound: "No results found",
};

export const _JOURS_SEMAINE = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const _MONTHS = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const _CO = {
  1: 7,
  2: 8,
  3: 9,
  4: 10,
  5: 11,
  6: 12,
  7: 1,
  8: 2,
  9: 3,
  10: 4,
  11: 5,
  12: 6,
};

export const _ROLES = [
  { id: 1, value: "ROLE_ADMIN", label: "Administrator" },
  { id: 2, value: "ROLE_CTRL", label: "Controller" },
  { id: 3, value: "ROLE_SALES", label: "Sales" },
  { id: 4, value: "ROLE_HR", label: "Human Ressources" },
  { id: 5, value: "ROLE_PAYROLL", label: "Payroll" },
  { id: 6, value: "ROLE_IT", label: "I.T" },
  { id: 7, value: "ROLE_ENGINEERING", label: "Engineering" },
  { id: 8, value: "ROLE_FLEET_OP", label: "Fleet Operator" },
  { id: 9, value: "ROLE_HEALTH_SAFETY", label: "Health Safety" },
  { id: 10, value: "ROLE_LRU", label: "LRU" },
];

export const _ROLES_BACK = {
  _ROLE_USER: "ROLE_USER",
  _ROLE_ADMIN: "ROLE_ADMIN",
  _ROLE_CTRL: "ROLE_CTRL",
  _ROLE_PAYROLL: "ROLE_PAYROLL",
  _ROLE_SALES: "ROLE_SALES",
  _ROLE_HR: "ROLE_HR",
  _ROLE_IT: "ROLE_IT",
  _ROLE_ENGINEERING: "ROLE_ENGINEERING",
  _ROLE_FLEET_OP: "ROLE_FLEET_OP",
  _ROLE_HEALTH_SAFETY: "ROLE_HEALTH_SAFETY",
  _ROLE_LRU: "ROLE_LRU",
  _ROLE_LRL: "ROLE_LRL",
  _ROLE_DEPRECIATION: "ROLE_DEPRECIATION",
};

export const _ROLES_ADMIN = [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL];

export const _SITE_TYPES = [
  { id: 1, value: "UBP", label: "UBP Production" },
  { id: 2, value: "DEPOT", label: "Depot" },
  { id: 3, value: "SISTER_COMPANY", label: "Sister Company" },
];

export const _ACTIVE_RADIO_GROUP = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];

// ACTIVITIES
export const _ACTIVITIES = {
  FILAIRE: "FILAIRE",
  BLOCK: "BLK",
  LRU: "LRU",
  AGG: "AGG",
  OVH: "OVH",
  PRECAST: "PRECAST",
  CCP: "CCP",
  MARBLE: "MARBLE",
  RUSTIC: "RUSTIC",
  VORTEX: "VORTEX",
  PREDALLES: "PREDALLES",
};

export const CALC_OPERATIONS = {
  SUM: "sum",
  MULTIPLY: "multiply",
};

export const TYPE_SITE = {
  DEPOT: "DEPOT",
};

export const _SALE_INPUTS = {
  aggregates: "Aggregates",
  crusherRun: "Crusher Run",
  rocksand: "Rocksand",
  spallsFilterBoulders: "Spalls filter boulders",
};

export const _INPUT_SALE_REGROUPING = {
  EXTERNAL_CREDIT_DISCOUNT_GROUPING: "Discount Credit",
  EXTERNAL_CASH_GROUPING: "EXTERNAL CASH",
  EXTERNAL_CREDIT_GROUPING: "EXTERNAL CREDIT",
  PMX_GROUPING: "EXTERNAL CREDIT PMX",
  DMX_GROUPING: "EXTERNAL CREDIT DMX",
  GCC_GROUPING: "EXTERNAL CREDIT GCC",
  OTHER_GROUPING: "EXTERNAL CREDIT OTHERS CUSTUMER",
  UNSECURED_GROUPING: "UNSECURED CREDIT",
  BOLCK_GROUPING: "BLOCK",
  TOTAL_GROUPING: "TOTAL",
  DEPOT_GROUPING: "DEPOTS",
  VOLUMES_GROUPING: "VOLUMES",
  TURN_GROUPING: "TURN OVER",
  PRODUCT_GROUPING: "PRODUCTS",
};

export const _INPUT_SALE_DEPOTS = {
  TERRE_ROUGE: "Terre Rouge",
  VALENTINA: "Valentina",
};

export const _INPUT_SALE_TURN_OVER = {
  EXTERNAL_TURN_OVER: "EXTERNAL TURN OVER",
  INTERNAL_TURN_OVER: "INTERNAL TURN OVER",
};

export const _INPUT_SALES_OTHERS = {
  DISCOUNT_PMX: "Discount PMX",
  DISCOUNT_DMX: "Discount DMX",
  UNSECURED_CREDIT: "UNSECURED CREDIT",
  TOTAL_EXTERNAL_INTERNAL: "Total External + Internal",
  INTERNAL: "INTERNAL",
  BY_PRODUCT_RS: "By Product Rs",
  INTERNAL_BLOCK: "Internal (Block Only)",
  EXTERNAL_VOLUME: "EXTERNAL VOLUMES",
  INTERNAL_VOLUME: "INTERNAL VOLUMES",
  CREDIT_DISCOUNT: "Credit discount",
};

export const _TAB_INPUT_SALES = {
  VOLUME: "volume",
  VALUE: "value",
};

export const _HEADERS_NAME_INPUT_SALES = {
  CASH: "CASH",
  CREDIT: "CREDIT",
  DISCOUNT: "DISCOUNT",
  TOTAL: "Total",
};
